// src/lib/bedAvailability.js
// Availability + labeling for the garden-bed screen, derived entirely from
// gardenBedLayouts.json so newly generated beds appear with zero UI edits.
import gardenBedLayouts from '../data/gardenBedLayouts.json';

// Known depths for legacy entries generated before heightFt was persisted.
const LEGACY_DEPTHS = { 12: 6, 15: 8, 18: 9 };

const matchesStyle = (entry, style) => !style || entry.style === style;

export function availableShapes(style) {
  const shapes = new Set();
  for (const e of gardenBedLayouts) {
    if (matchesStyle(e, style)) shapes.add(e.shape);
  }
  return [...shapes];
}

export function availableSizes(shape, style) {
  const sizes = new Set();
  for (const e of gardenBedLayouts) {
    if (e.shape === shape && matchesStyle(e, style)) sizes.add(e.bedSize);
  }
  return [...sizes].sort((a, b) => a - b);
}

// Stale-size rule for shape changes: keep a still-valid size, auto-select a sole
// option, otherwise clear. Called at the SET_SHAPE dispatch sites.
export function nextBedSize(shape, style, currentSize) {
  const sizes = availableSizes(shape, style);
  if (currentSize != null && sizes.includes(currentSize)) return currentSize;
  if (sizes.length === 1) return sizes[0];
  return null;
}

export function sizeLabel(shape, size, style) {
  const withDepth =
    gardenBedLayouts.find(
      (e) => e.shape === shape && e.bedSize === size && matchesStyle(e, style) && e.heightFt !== undefined
    ) ||
    gardenBedLayouts.find((e) => e.shape === shape && e.bedSize === size && e.heightFt !== undefined);
  // floor, not round: a 21.5 ft bed reads "x 21'" (round would overstate to 22).
  const depth = withDepth ? Math.floor(withDepth.heightFt) : LEGACY_DEPTHS[size];
  return depth ? `${size}' x ${depth}'` : `${size}'`;
}
